export const SPELLING_ERROR_TYPES_ENGLISH = [
  'Phonetic approximation',
  'Silent letter omitted',
  'Vowel digraph error',
  'Consonant blend error',
  'Double letter error',
  'Common/sight word error',
  'Homophones confusion',
  'Letter reversal',
  'Suffix/prefix error',
  'Irregular pattern error'
];

export const SPELLING_ERROR_TYPES_KANNADA = [
  'Matra error (ಮಾತ್ರಾ ತಪ್ಪು)',
  'Gunintham error (ಗುಣಿತಾಂಕ ತಪ್ಪು)',
  'Anusvara/Visarga error (ಅನುಸ್ವಾರ/ವಿಸರ್ಗ)',
  'Vattakshara error (ಒತ್ತಕ್ಷರ ತಪ್ಪು)',
  'Akshara confusion (ಅಕ್ಷರ ಗೊಂದಲ)',
  'Phonetic approximation (ಧ್ವನಿ ಆಧಾರಿತ)',
  'Matra length confusion (ಮಾತ್ರಾ ಉದ್ದ ತಪ್ಪು)',
  'Halant omission (ಹಲಂತ ಬಿಟ್ಟುಬಿಡುವಿಕೆ)',
  'Letter reversal (ಅಕ್ಷರ ಹಿಮ್ಮುಖ)',
  'Archaic form used (ಹಳೆಯ ರೂಪ)'
];

export const WRITING_LEGIBILITY_OPTIONS = [
  'Excellent - Consistently clear and easy to read',
  'Good - Generally clear with minor issues',
  'Fair - Readable but requires effort',
  'Poor - Difficult to read consistently',
  'Very Poor - Mostly illegible'
];
